import React from 'react';
import { ListItem, ListItemIcon, ListItemText, Tooltip } from '@material-ui/core'
import { LocationDescriptor } from 'history';
import { Link } from 'react-router-dom';
import { TranslationKey } from '../../translations/TranslationKey';
import TranslatedMessage from '../translations/TranslatedMessage';

interface ListItemLinkProps {
  to: LocationDescriptor;
  translationKey: TranslationKey;
  children: React.ReactElement;
}

const ListItemLink: React.FC<ListItemLinkProps> = ({ to, children, translationKey }) => {
  return (
    <Tooltip title={<TranslatedMessage id={translationKey} />}>
      <ListItem
        button
        component={Link} to={to}
      >
        <ListItemIcon>
          {children}
        </ListItemIcon>
        <ListItemText primary={<TranslatedMessage id={translationKey} />} />
      </ListItem>
    </Tooltip>
  );
}

export default ListItemLink;
